import { gql } from '@apollo/client';
export const AUTH_CONFIG_FIELDS = gql `
  fragment AuthConfigFields on AuthConfig {
    id
    clientId
    name
    provider
    isActive
    config
    samlUseNameid
    samlAttributeName
    samlIdentifierField
    extraData
    createdAt
    updatedAt
  }
`;
export const AUTH_CONFIGS = gql `
  ${AUTH_CONFIG_FIELDS}
  query AUTH_CONFIGS($spec: AuthConfigSpec!) {
    authConfigs(spec: $spec) {
      ...AuthConfigFields
    }
  }
`;
export const CURRENT_AUTH_CONFIGS = gql `
  query CURRENT_AUTH_CONFIGS {
    currentAuthConfigs {
      id
      name
      provider
    }
  }
`;
export const SAVE_AUTH_CONFIG = gql `
  ${AUTH_CONFIG_FIELDS}
  mutation SAVE_AUTH_CONFIG($input: AuthConfigInput!) {
    saveAuthConfig(input: $input) {
      ...AuthConfigFields
    }
  }
`;
export const DELETE_AUTH_CONFIG = gql `
  ${AUTH_CONFIG_FIELDS}
  mutation DELETE_AUTH_CONFIG($id: Int!) {
    deleteAuthConfig(id: $id) {
      ...AuthConfigFields
    }
  }
`;
